import {
  GET_TIME_ENTRIES,
  CREATE_TIME_ENTRY,
  UPDATE_TIME_ENTRY,
  DELETE_TIME_ENTRY,
  START_TIMER,
  STOP_TIMER
} from '../actions/timeEntryActions';

const initialState = {
  timeEntries: [],
  activeTimer: null,
  isLoading: false
};

const timeEntryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TIME_ENTRIES:
      return {
        ...state,
        timeEntries: action.payload.timeEntries,
        isLoading: false
      };

    case CREATE_TIME_ENTRY:
      return {
        ...state,
        timeEntries: [action.payload, ...state.timeEntries]
      };

    case UPDATE_TIME_ENTRY:
      return {
        ...state,
        timeEntries: state.timeEntries.map(te =>
          te._id === action.payload._id ? action.payload : te
        )
      };

    case DELETE_TIME_ENTRY:
      return {
        ...state,
        timeEntries: state.timeEntries.filter(te => te._id !== action.payload)
      };

    case START_TIMER:
      return {
        ...state,
        activeTimer: action.payload
      };

    case STOP_TIMER:
      return {
        ...state,
        activeTimer: null,
        timeEntries: [action.payload, ...state.timeEntries]
      };

    default:
      return state;
  }
};

export default timeEntryReducer;
